import { render, staticRenderFns } from "./DialogInspectVars.vue?vue&type=template&id=06d806a4"
import script from "./DialogInspectVars.vue?vue&type=script&lang=js"
export * from "./DialogInspectVars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports